export const MEMBER_ROUTES = {
  journal: "journal",
  "member-summary": "member-summary",
  messages: "messages",
  "personal-details": "personal-details",
  reports: "reports",
  "workout-plan": "workout-plan",
};
